// Send email
export const SEND_EMAIL = 'SEND_EMAIL';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR';
export const SEND_EMAIL_CLEAR_ERROR_RESPONSE = 'SEND_EMAIL_CLEAR_ERROR_RESPONSE';
export const CANCEL_EMAIL_VERIFY = 'CANCEL_EMAIL_VERIFY';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_ERROR = 'VERIFY_EMAIL_ERROR';

// Remove email
export const REMOVE_EMAIL = 'REMOVE_EMAIL';
export const REMOVE_EMAIL_SUCCESS = 'REMOVE_EMAIL_SUCCESS';
export const REMOVE_EMAIL_ERROR = 'REMOVE_EMAIL_ERROR';

// Account recovery
export const SEND_RECOVERY_EMAIL = 'SEND_RECOVERY_EMAIL';
export const SEND_RECOVERY_EMAIL_SUCCESS = 'SEND_RECOVERY_EMAIL_SUCCESS';
export const SEND_RECOVERY_EMAIL_ERROR = 'SEND_RECOVERY_EMAIL_ERROR';
export const RESET_SEND_RECOVERY_EMAIL_STATE = 'RESET_SEND_RECOVERY_EMAIL_STATE';

// Email verification types
export const VERIFY_EMAIL_TYPE_OTP = 'VERIFY_EMAIL_TYPE_OTP';
export const VERIFY_EMAIL_TYPE_GOOGLE = 'VERIFY_EMAIL_TYPE_GOOGLE';
export const SET_SECOND_FACTOR_THIRD_PARTY = 'SET_SECOND_FACTOR_THIRD_PARTY';

// Websocket
export const EMAIL_COLLECTION_SETTINGS_RECEIVED = 'EMAIL_COLLECTION_SETTINGS_RECEIVED';

// Marketing options
export const SET_MARKETING_EMAIL_OPTIONS = 'SET_MARKETING_EMAIL_OPTIONS';
export const SET_EMAIL_OTP_LENGTH = 'SET_EMAIL_OTP_LENGTH';
export const SET_MASKED_EMAIL = 'SET_MASKED_EMAIL';

// Email OTP
export const SET_EMAIL_AUTH_STATE = 'SET_EMAIL_AUTH_STATE';
export const VALIDATE_EMAIL_OTP_SUCCESS = 'VALIDATE_EMAIL_OTP_SUCCESS';
export const VALIDATE_EMAIL_OTP_ERROR = 'VALIDATE_EMAIL_OTP_ERROR';
export const RESET_VALIDATE_EMAIL_OTP_STATE = 'RESET_VALIDATE_EMAIL_OTP_STATE';

// Google Token
export const VALIDATE_GOOGLE_TOKEN_SUCCESS = 'VALIDATE_GOOGLE_TOKEN_SUCCESS';
export const VALIDATE_GOOGLE_TOKEN_ERROR = 'VALIDATE_GOOGLE_TOKEN_ERROR';
export const RESET_GOOGLE_TOKEN = 'RESET_GOOGLE_TOKEN';

// Dialog UI States
export const EMAIL_AUTH_STATE_EMAIL = 'Email';
export const EMAIL_AUTH_STATE_OTP = 'Otp';
export const EMAIL_AUTH_STATE_THIRD_PARTY_NOT_FOUND = 'ThirdPartyNotFound';
export const EMAIL_AUTH_STATE_THIRD_PARTY_VERIFICATION = 'ThirdPartySecondFactor';

// Marketing Email Consent Types
export const MARKETING_EMAIL_CONSENT_TYPE_DEFAULT_CHECKED_OPT_IN =
  'default_checked_opt_in' as const;
export const MARKETING_EMAIL_CONSENT_TYPE_NONE = 'none' as const;
export const MARKETING_EMAIL_CONSENT_TYPE_OPT_IN = 'opt_in' as const;
export const MARKETING_EMAIL_CONSENT_TYPE_OPT_OUT = 'opt_out' as const;

// ERROR CODES
// Email Error Codes
export const INVALID_EMAIL = 40009;
export const EMAIL_RATE_LIMIT_HIT = 42904;

// Email OTP Error Codes
export const INVALID_OTP = 41202;
export const EMAIL_OTP_COUNT_LIMIT_HIT = 42903;
export const TOO_MANY_INVALID_OTP = 42907;

type ErrorMappingType =
  | typeof INVALID_EMAIL
  | typeof EMAIL_RATE_LIMIT_HIT
  | typeof INVALID_OTP
  | typeof EMAIL_OTP_COUNT_LIMIT_HIT
  | typeof TOO_MANY_INVALID_OTP;

// Error code-to-message map
export const HANDLED_ERROR_MAPPING: Record<ErrorMappingType, string> = {
  [INVALID_EMAIL]: 'EmailCollection.invalidEmail',
  [EMAIL_RATE_LIMIT_HIT]: 'EmailCollection.emailRateLimitHit',
  [INVALID_OTP]: 'EmailCollection.invalidCode',
  [EMAIL_OTP_COUNT_LIMIT_HIT]: 'EmailCollection.otpCountLimitHit',
  [TOO_MANY_INVALID_OTP]: 'EmailCollection.tooManyInvalidOtp',
};
